<template>
  <div :key="renderKey">
    <div class="row">
      <el-table style="font-size:12px;text-wrap: wrap;" :data="options" role="table" aria-label="User Documents Table">
        <el-table-column v-if="!editable" :min-width="150" align="left" label="Actions">
          <div slot-scope="props">
            <el-tooltip v-if="$route.path != '/Account/UserProfile'" content="Edit Document" :open-delay="300"
              effect="light" placement="top">
              <a href="##" @click.stop.prevent="handleEdit(props.row)" class="btn-link btn-danger">
                <i class="tim-icons icon-pencil"></i>
              </a>
            </el-tooltip>
            <span v-if="$route.path != '/Account/UserProfile'" class="hide-if-medium-screensize">|</span>

            <el-tooltip content="Delete Document" class="display-inline" :open-delay="300" effect="light"
              placement="top">
              <a href="##" @click.stop.prevent="handleDelete(props.row.id, props.row.name)" class="btn-link btn-danger">
                <i class="tim-icons icon-trash-simple"></i>
              </a>
            </el-tooltip>

            <span class="hide-if-medium-screensize">|</span>
            <el-tooltip content="Download Document" :open-delay="300" effect="light" placement="top">
              <router-link :to="`/api/applicationuserfiles/${props.row.id}`" class="btn-link btn-primary"
                target="_blank">
                <i class="tim-icons icon-cloud-download-93"></i>
              </router-link>
            </el-tooltip>

          </div>

        </el-table-column>

        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" sortable
          :formatter="column.formatter" :prop="column.prop" :label="column.label">

        </el-table-column>
        <el-table-column min-width="150" sortable label="UPLOAD DATE">

          <template slot-scope="scope">
            {{ formatDate(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" sortable label="Document Date">

          <editable-date-cell
    slot-scope="{ row }"
     v-model="row.documentDate"
    :show-input="row.id == editingRowId"
    format="dd-MMMM-yyyy"
    value-format="yyyy-MM-dd"
    date-type="date"
    @change="(newDate) => updateAdminUserFiles(row.id, row.userId, newDate)"
  />

        </el-table-column>
      </el-table>
    </div>
    <div class="row align-center">
      <UserDocumentsModal :email="email" :isNew="true" :type="type" @reloadDocuments="handleFileAdded()">
        <template v-slot:modal-link>
          <base-button :disabled="editable" class="btn-dark"><span><i class="tim-icons icon-simple-add"></i> Add
              Documentation</span></base-button>
        </template>
      </UserDocumentsModal>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import Util from "@/util/util";
import moment from "moment";
import EditableDateCell from '@/components/Table/EditableDateCell.vue';
import { BaseSwitch, BaseButton, Modal, EditableCell  } from "@/components";
import UserDocumentsModal from "@/components/App/account/documents/UserDocumentsModal.vue";
import UserDocumentsDelete from "@/components/App/account/documents/UserDocumentsDelete.vue";
import swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
const options = {
  'Content-Type': 'application/json',
  config: { showToast: false }
};
export default {
  name: "UserDocuments",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    UserDocumentsModal,
    EditableCell,
    UserDocumentsDelete,
    EditableDateCell
  },

  props: {
    email: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    renderKey: 0,
    tableColumns: [
      {
        prop: "name",
        label: "NAME",
        minWidth: 100,
        scope: "col"
      },
      {
        prop: "type",
        label: "TYPE",
        minWidth: 100,
        scope: "col"
      },
    ],
    editMode: false,
    editingRowId: null,
  }),
  computed: {
    ...mapGetters({
      user: "users/user"
    }),
  },
  watch: {
    async email(newEmail, oldEmail) {
      if (newEmail !== oldEmail) {
        await this.reRenderDocuments();
      }
    },
  },
 async  mounted() {
    this.options = [];
   await  this.reRenderDocuments();
  },
  methods: {
    ...mapActions({
      getUser: "users/getUser"
    }),
   async  reRenderDocuments() {
      const userId = this.$route.params.id;
      if (userId) {
         // Admin Profile - use store data if available
         if (this.user && this.user.files) {
             this.options = this.user.files.map(f => ({
                 id: f.id,
                 userId: f.userId,
                 name: f.filename,
                 type: f.fileTypeName,
                 createDate: f.createDate,
                 updateDate: f.updateDate,
                 documentDate: f.documentDate
             }));
             return;
         }
      }

      if (this.email) {
        // Admin Profile
        await this.getAdminUserFiles();
      } else {
        // User Profile
        await this.getFiles();
      }
    },
    async refreshParentUser() {
      // Refresh user data after file operations (same pattern as LockButton)
      const userId = this.$route.params.id;
      if (userId) {
        await this.getUser(userId);
      }
    },
    async handleFileAdded() {
      await this.refreshParentUser();
      await this.reRenderDocuments();
    },
    async handleEdit(row) {
      if (this.editingRowId === row.id) {
        // Row Updating Section
        this.editMode = false;
        this.editingRowId = null;
      } else {
        this.editMode = true;
        this.editingRowId = row.id;
      }
    },
    async deleteAndRerender(fileId) {
      try {
        await this.axios.delete(`api/applicationuserfiles/delete/${fileId}`, options);
        // Only refresh user data after successful delete
        await this.refreshParentUser();
        await this.reRenderDocuments();
        this.$toast.success('Document deleted successfully');
      } catch (error) {
        let errorMessage = "Error deleting document";
        if (error.response && error.response.data) {
          if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.$toast.error(errorMessage);
      }
    },
    handleDelete(fileId, nameOfFile) {
      new swal({
        title: "Delete File",
        html: `Do you want to delete ${nameOfFile}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.deleteAndRerender(fileId);
        }
      });
    },
    formatDate(date) {
      if (!date) return "";
      const momentDate = moment(date);
      if (!momentDate.isValid()) return "";
      return momentDate.format("DD-MMMM-YYYY HH:mm:ss");
    },
    formatDateLocalTime(value) {
      if (!value) return "";
      const date = moment(value);
      if (!date.isValid()) return "";
      return date.format("DD-MMMM-YYYY");
    },
   async  getAdminUserFiles() {
      let ctx = this;
      const encodedEmail = encodeURIComponent(ctx.email); // Bug-fix #17661

     try {
       await ctx.axios
        .get(`api/applicationuserfiles/user/email/${encodedEmail}`, options)
        .then( (response) => {
          //Load the data
           ctx.options = response.data.map((old) => {
            return {
              id: old.id,
              userId:old.userId,
              name: old.filename,
              type: old.filetype,
              expiration: old.expiration,
              createDate: old.createDate,
              updateDate: old.updateDate,
              documentDate: old.documentDate

            };
          });
        });
     } catch (error) {
       // Extract the error message from the response
       let errorMessage = "Error loading user files";
       if (error.response && error.response.data) {
         if (typeof error.response.data === 'string') {
           errorMessage = error.response.data;
         } else if (error.response.data.detail) {
           errorMessage = error.response.data.detail;
         } else if (error.response.data.message) {
           errorMessage = error.response.data.message;
         } else if (error.response.data.error) {
           errorMessage = error.response.data.error;
         } else if (error.response.data.title) {
           errorMessage = error.response.data.title;
         }
       }
       ctx.$toast.error(errorMessage);
     }
    },
    updateAdminUserFiles(id, userId, date) {
      let ctx = this;
      let formData = new FormData();
      formData.append('DocumentDate', new Date(date).toISOString());
       formData.append('UserId', userId);
 
      // for user profile/regristrations we just want to allowe the urer end point
      // for everyone else pass through the admin validations
      // if no type is passed we also assum its personal
      let url = (!this.type || this.type === "personal") 
      ? `api/applicationuserfiles/user/${id}` : `api/applicationuserfiles/admin/${id}`;

      ctx.axios
        .put(url, formData, options)
        .then(async (response) => {
          // get 
          //Load the data
          await ctx.refreshParentUser();
          await ctx.reRenderDocuments();
           ctx.$toast.success("Document updated successfully");
        }
      ).catch(async (error) => {
        // Extract the error message from the response
        let errorMessage = "Error updating document";
        if (error.response && error.response.data) {
          if (typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else if (error.response.data.detail) {
            errorMessage = error.response.data.detail;
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.data.title) {
            errorMessage = error.response.data.title;
          }
        }
        ctx.$toast.error(errorMessage);
        await ctx.reRenderDocuments();
      });
      this.editMode = false;
      this.editingRowId = null;
    },
   async  getFiles() {
     try {
       await  this.axios.get(`api/applicationuserfiles/user/email`, options).then((response) => {
        //Load the data
        this.options = response.data.map((old) => {
          return {
            id: old.id,
            name: old.filename,
            type: old.filetype,
            expiration: old.expiration,
            createDate: old.createDate,
            updateDate: old.updateDate

          };
        });
      });
     } catch (error) {
       // Extract the error message from the response
       let errorMessage = "Error loading user files";
       if (error.response && error.response.data) {
         if (typeof error.response.data === 'string') {
           errorMessage = error.response.data;
         } else if (error.response.data.detail) {
           errorMessage = error.response.data.detail;
         } else if (error.response.data.message) {
           errorMessage = error.response.data.message;
         } else if (error.response.data.error) {
           errorMessage = error.response.data.error;
         } else if (error.response.data.title) {
           errorMessage = error.response.data.title;
         }
       }
       this.$toast.error(errorMessage);
     }
    },
  },
};
</script>

<style scoped>
/* This is for "Delete | Download" type of styling in AGATRS */

@media only screen and (max-width: 1510px) {
  .hide-if-large-screensize {
    display: none;
  }
}

@media only screen and (max-width: 800px) {
  .hide-if-medium-screensize {
    display: none;
  }
}
</style>
